import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowUpSquare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"arrow-up-square, top"} maskId="square-filled-radius-0-stroke-1-IconArrowUpSquare"><path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM7.79297 11L8.5 11.707L11.5 8.70703V17H12.5V8.70703L15.5 11.707L16.207 11L12 6.79297L7.79297 11Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconArrowUpSquare;
